import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import {
  Home,
  OrdersHistory,
  Page404,
  StoreScreen,
  VerifyEmail,
} from "./screens/exports";
import { useNavigate, useLocation } from 'react-router-dom';
import { Navigate, Route, Routes } from "react-router-dom";
import { Loader } from "./components/exports";
import SelectStore from "./screens/Home/StoreScreen/SelectStore/SelectStore";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { BaseURI, store } from "./shared";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n"; 
import {
  setOrder,
  setOrderNotification,
} from "./shared/slice/order/OrderSlice";
import { setRestaurantSelected, setTableNumber } from "./shared/slice/restaurant/RestaurantSlice";
import FirstPage from "./screens/FirstPage";
import { putNotificationservice } from "./shared/slice/ModalNotification/NotificationService";
import { setNotification } from "./shared/slice/ModalNotification/ModalNotification";
import messageSound from "./assets/son/Message-Iphone.mp3";
import ResetPassword from "./components/Modals/ResetPassword";
import { setProduct } from "./shared/slice/restaurant/RestaurantSlice";
import { getProductByStoreByMode } from "./shared/slice/restaurant/RestaurantService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setIsKioskLikely } from "./shared/slice/ModalLogin/ModalLoginSlice";

import socketIOClient, { io } from "socket.io-client";
import QrCodePage from "./screens/Home/StoreScreen/SelectStore/QrCodePage";
import { generateToken, messaging } from "./noltifications/firebase";
import { onMessage } from "firebase/messaging";
import FirstPage2 from "./screens/FirstPage2";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService/TermsOfService";
import { toast } from 'react-toastify';
import StoreBySpeciality from "./screens/Home/StoreScreen/StoreBySpeciality";
import { SocketProvider, useSocket } from "./utils/socketContext";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
  locale: "en", // Set the locale to French
});
function App() {
  window.onload = function () {
    window.opener?.postMessage(
      { status: "loaded", url: window.location.href },
      "*"
    );
  };
    const dispatch = useDispatch();
  const { socket, connected, joinRoom, joinStoreRoom,addEventListener, removeEventListener } = useSocket();
  const loggedInUser = useSelector((state) => state.authentification.loggedInUser);
  const loggedInGuest = useSelector((state) => state.authentification.loggedInGuest);
  const restaurantSelected = useSelector((state) => state.restaurant.restaurantSelected); 
  const navigate = useNavigate();
  const location = useLocation();
  const { mode: storeModes } = useSelector((state) => state.restaurant);
  const isLoading = useSelector((state) => state.root.isLoading);
  const scroll = useSelector((state) => state.scroll.scroll);
  const modeSelectedId = useSelector((state) => state.restaurant.modeSelectedId);

  // Navigation handler
useEffect(() => {
  console.log('🔄 Navigation handler triggered');
  console.log('📍 Location:', location.pathname, location.search);
  
  const params = new URLSearchParams(location.search);
  let slug = params.get("slug");
  const modeParam = params.get("mode");
  const table = params.get("table");

  // Extraire le slug du path
  const pathMatch = location.pathname.match(/^\/([^\/\?\#]+)/);
  const pathSlug = pathMatch ? pathMatch[1] : null;
  
  if (!slug && pathSlug && pathSlug !== "") {
    slug = pathSlug;
  }

  console.log('🏷️ Detected slug:', slug, 'mode:', modeParam, 'table:', table);

  // Routes système à ignorer
  const systemRoutes = [
    "", "home", "company", "privacy-policy", "terms-of-service", 
    "page404", "ordershistory", "verify-email", "reset-password", "companyId"
  ];
  
  const isValidStoreSlug = slug && !systemRoutes.includes(slug) && !slug.includes('companyId');
  
  if (isValidStoreSlug) {
    console.log('✅ Valid store slug detected:', slug);
    
    // 1. Gérer le numéro de table
    if (table && parseInt(table, 10) > 0) {
      const tableNumber = parseInt(table, 10).toString();
      dispatch(setTableNumber({ tableNumber }));
      localStorage.setItem("tableNumber", tableNumber);
      console.log('🪑 Table number set:', tableNumber);
    }
    
    // 2. Gérer le mode dans localStorage
    if (modeParam) {
      localStorage.setItem("mode", modeParam);
      console.log('🎯 Mode saved to localStorage:', modeParam);
    }

    // 3. Initialiser le store de manière asynchrone
    const initializeAsync = async () => {
      try {
        const { initializeStore } = require("./utils/storeNavigation");
        const initialized = await initializeStore(slug);
        
        if (initialized) {
          console.log('🏪 Store initialized successfully');
          
          // Si on est sur une route de store spécifique, naviguer vers SelectStore
          if (location.pathname === `/${slug}`) {
            console.log('🧭 Navigating to SelectStore component');
            // La navigation se fait automatiquement via React Router
          }
        } else {
          console.error('❌ Store initialization failed');
        }
      } catch (err) {
        console.error('❌ Error during store initialization:', err);
      }
    };
    
    initializeAsync();
  } else {
    console.log('ℹ️ Not a store slug or system route, skipping store initialization');
  }
}, [location.pathname, location.search, dispatch]);


useEffect(() => {
  // Ne s'exécuter que si on a un restaurant et des modes chargés
  if (!restaurantSelected || !storeModes || storeModes.length === 0) {
    return;
  }
  
  const params = new URLSearchParams(location.search);
  const modeParam = params.get("mode");
  
  if (!modeParam) {
    console.log('ℹ️ No mode parameter, user will select manually');
    return;
  }
  
  console.log('🎯 Processing mode parameter:', modeParam);
  console.log('📦 Available modes:', storeModes);
  
  // Vérifier si le mode n'est pas déjà sélectionné
  const currentModeId = store.getState().restaurant.modeSelectedId;
  const currentMode = storeModes.find(m => m.mode._id === currentModeId);
  
  if (currentMode && currentMode.mode.name === modeParam) {
    console.log('✅ Mode already selected correctly');
    return;
  }
  
  // Trouver et sélectionner le mode
  const normalize = str => str.replace(/[\s\-_]/g, '').toLowerCase();
  const foundMode = storeModes.find(
    (m) => m.mode && typeof m.mode.name === "string" && 
    normalize(m.mode.name) === normalize(modeParam)
  );

  if (foundMode) {
    console.log('✅ Setting mode:', foundMode.mode.name);
    
    dispatch({ type: "restaurant/setModeSelectedId", payload: { modeSelectedId: foundMode.mode._id } });
    dispatch({ type: "restaurant/setModeName", payload: { modeName: foundMode.mode.name } });
    dispatch({ type: "modalMode/setModesModal", payload: { modesModal: false } });
    
    // Charger les produits pour ce mode
    console.log('🔄 Loading products for mode:', foundMode.mode._id);
    getProductByStoreByMode(restaurantSelected._id, foundMode.mode._id)
      .then(res => {
        console.log('✅ Products loaded:', res);
        dispatch(setProduct({ product: res }));
      })
      .catch(err => {
        console.error('❌ Failed to load products:', err);
      });
  } else {
    console.warn('⚠️ Mode not found in available modes:', modeParam);
  }
}, [restaurantSelected, storeModes, location.search, dispatch]);

useEffect(() => {
    // Only fetch if mode param exists in URL, and both are set
    const params = new URLSearchParams(location.search);
    const modeParam = params.get("mode");
    if (restaurantSelected && modeSelectedId && modeParam) {
      getProductByStoreByMode(restaurantSelected._id, modeSelectedId)
        .then(res => {
          dispatch(setProduct({ product: res }));
        });
    }
  }, [restaurantSelected, modeSelectedId, location.search, dispatch]);

useEffect(() => {
    generateToken();
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      const { token, orderts } = payload.data;
      const firebaseToken = localStorage.getItem("firebaseToken");
      if (token === firebaseToken) {
        if (payload.notification) {
          const { title, body } = payload.notification;
          new Notification(title, {
            body,
            icon: "/eatorder-FAV.svg",
            data: { url: "https://market.eatorder.fr/" },
          });
        }
      }
    });
    return () => unsubscribe();
  }, []);

  // Kiosk detection
  useEffect(() => {
    const checkKiosk = () => {
      const isTouchDevice = navigator.maxTouchPoints > 0;
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const fixedScreenRatio =
        screenHeight / screenWidth >= 1.5 && screenHeight > 1500;

      store.dispatch(
        setIsKioskLikely({ IsKioskLikely: isTouchDevice && fixedScreenRatio })
      );
    };

    checkKiosk();
  }, []);

  useEffect(() => {
    if (scroll === 0) {
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [scroll]);

  useEffect(() => {
    if (isLoading === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

 // State and context for audio unlocking
  const [isAudioUnlocked, setIsAudioUnlocked] = useState(false);
  let audioContext = null;

  // Detect if running in Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // Unlock audio and initialize context on user interaction
  useEffect(() => {
    const unlockAudio = async () => {
      if (isAudioUnlocked) return; // Prevent multiple initializations
      setIsAudioUnlocked(true);

      if (isSafari) {
        try {
          if (!audioContext) {
            audioContext = new (window.AudioContext)();
            console.log(`🔊 [Audio] AudioContext created, state: ${audioContext.state}`);
          }
          if (audioContext.state === 'suspended') {
            await audioContext.resume();
            console.log(`🔊 [Audio] AudioContext resumed, state: ${audioContext.state}`);
          }
          // Attempt to set speaker output
          if (audioContext.setSinkId) {
            try {
              await audioContext.setSinkId('default');
              console.log('🔊 [Audio] Audio output set to default (speaker)');
            } catch (error) {
              console.error('❌ [Audio] Failed to set speaker output:', error);
            }
          }
        } catch (error) {
          console.error('❌ [Audio] AudioContext initialization failed:', error);
        }
      }

      // Play silent sound to initialize audio context
      const silentSound = new Audio('/static/media/silent.mp3');
      silentSound.volume = 0; // Ensure silent
      silentSound.play().catch((error) => {
        console.error('❌ [Audio] Failed to play silent sound:', error);
        toast({
          type: 'error',
          text1: 'Failed to initialize audio. Please tap again.',
        });
      });

      // Remove listeners after first interaction
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };

    document.addEventListener('click', unlockAudio);
    document.addEventListener('touchstart', unlockAudio);
    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, [isAudioUnlocked]);

  // Socket useEffect
  useEffect(() => {
    if (loggedInUser || loggedInGuest) {
      // Establish socket connection
      const socket = io(BaseURI);

      // Event listener for socket connection
      const connectListener = () => {
        const userId = loggedInUser ? loggedInUser._id : loggedInGuest?._id;
        socket.emit('join_room_orders', userId.toString());
      };

      // Event listener for receiving orders
      const receiverOrders = async (data) => {
        console.log('✅ [Socket] Data received:', data);

        data = data.data;

        if (loggedInUser || loggedInGuest) {
          const userId = loggedInUser ? loggedInUser._id : loggedInGuest._id;
          console.log('👤 [Socket] User ID:', userId);

          try {
            if (JSON.parse(data) instanceof Object) {
              console.log('📦 [Socket] Parsed data is valid JSON object');

              store.dispatch(setOrderNotification({ OrderNotification: data }));

              const eventData = JSON.parse(data);
              const messages = eventData.status;
              console.log('📨 [Socket] Order status:', messages);
              console.log('🆔 [Socket] Order ID:', eventData.orderId);

              if (['rejected', 'missed', 'accepted', 'ready'].includes(messages)) {
                try {
                  console.log('🔔 [Socket] Triggering notification update...');
                  const resp = await putNotificationservice(eventData.orderId, messages, userId);

                  store.dispatch(setNotification({ Notification: resp.notification }));
                  console.log('✅ [Socket] Notification updated successfully');

                  if (!isAudioUnlocked) {
                    console.log('🔇 [Socket] Audio not unlocked, waiting for user interaction');
                    toast.info( 'Tap the screen to enable notification sounds');
                    return;
                  }

                  if (isSafari && audioContext) {
                    // Ensure audio context is running
                    if (audioContext.state === 'suspended') {
                      await audioContext.resume();
                      console.log('🔊 [Socket] AudioContext resumed for playback');
                    }
                    setTimeout(() => {
                      fetch(messageSound)
                        .then((response) => response.arrayBuffer())
                        .then((arrayBuffer) => audioContext.decodeAudioData(arrayBuffer))
                        .then((audioBuffer) => {
                          const source = audioContext.createBufferSource();
                          source.buffer = audioBuffer;
                          source.connect(audioContext.destination);
                          source.start(0);
                          console.log('🔊 [Socket] Sound played via Web Audio API');
                        })
                        .catch((error) => {
                          console.error('❌ [Socket] Web Audio API error:', error);
                          toast.error('Failed to play notification sound. Ensure silent mode is off.');
                        });
                    }, 100); // Delay to stabilize context
                  } else {
                    // Fallback for other browsers
                    const sound = new Audio(messageSound);
                    sound.volume = 1.0;
                    sound.play()
                      .then(() => {
                        console.log('🔊 [Socket] Sound played via Audio API');
                      })
                      .catch((error) => {
                        console.error('❌ [Socket] Audio API error:', error);
                        toast.error('Failed to play notification sound. Ensure silent mode is off.');
                      });
                  }
                } catch (error) {
                  console.error('❌ [Socket] Error updating notification:', error);
                }
              }
            }
          } catch (err) {
            console.error('❌ [Socket] Error parsing data:', err);
          }
        }
      };

      socket.on('receive_orders', receiverOrders);
      socket.on('connect', connectListener);

      // Clean up event listeners on component unmount
      return () => {
        socket.off('connect', connectListener);
        socket.off('receive_orders', receiverOrders);
      };
    } else {
      // Disconnect socket if no user is logged in
      if (socket) {
        socket.disconnect();
      }
    }
  }, [loggedInUser, loggedInGuest]);

  function safeStringify(obj) {
    const seen = new Set();

    function recursiveStringify(value) {
      if (value && typeof value === "object") {
        if (seen.has(value)) {
          return undefined; // Skip circular references
        }
        seen.add(value);

        const result = {};
        for (const [key, val] of Object.entries(value)) {
          result[key] = recursiveStringify(val); // Recursively stringify the value
        }
        return result;
      }
      return value; // Return the primitive value
    }

    return JSON.stringify(recursiveStringify(obj));
  }

  return (
    <div className="App">
      <Loader isLoading={isLoading} />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        pauseOnHover={false}
      />
      {/* <SocketProvider> */}
        {/* <SocketManager /> */}
      <I18nextProvider i18n={i18n}>
        <Elements stripe={stripePromise}>
          <Routes>
            <Route path="/" element={<FirstPage />} />
            <Route path="/companyId/:companyId" element={<FirstPage2 />} />
            <Route path="/home" element={<Home />} />
            <Route path="/company/:id" element={<StoreScreen />} />
            <Route path="/:id" element={<SelectStore />} />
            <Route path="/:QrCode/QrCode/:vendeurId/:vendeur" element={<QrCodePage />}/>
            <Route path="/page404" element={<Page404 />} />
            <Route path="/ordershistory/:storeId" element={<OrdersHistory />}/>
            <Route path="/verify-email/:userId" element={<VerifyEmail />} />
            <Route path="/reset-password/:token" element={<ResetPassword />}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/*" element={<Navigate to="/" />} />
          </Routes>
        </Elements>
      </I18nextProvider>
      {/* </SocketProvider> */}
    </div>
  );
}

export default App;
